import { TableRow } from "./table-row";
import useBlockchainNetworks from "@/hooks/use-blockchain-networks";

export const TableBody = ({
	noEtrPersonaSelected,
	blockchainNetworks,
	loading,
	error,
	toggleBlockchainNetwork,
	etrIssuanceEnabled
}) => {
	// If error, display error message
	if (error) {
		return (
			<tbody className="etr-issuance__table-body etr-issuance__table-body--centered">
				<p>{error}</p>
			</tbody>
		);
	}

	// If loading, display loading message
	if (loading) {
		return (
			<tbody className="etr-issuance__table-body etr-issuance__table-body--centered">
				<p>Loading...</p>
			</tbody>
		);
	}

	// If no entries, display no entries message
	if (blockchainNetworks.length === 0) {
		return (
			<tbody className="etr-issuance__table-body etr-issuance__table-body--centered">
				<p>No entries to display</p>
			</tbody>
		);
	}

	return (
		<tbody className="etr-issuance__table-body etr-issuance__table-body--scrollable">
			{blockchainNetworks.map((network, index) => (
				<TableRow
					noEtrPersonaSelected={noEtrPersonaSelected}
					network={network}
					index={index}
					key={network.networkId}
					etrIssuanceEnabled={etrIssuanceEnabled}
					handleClick={() =>
						toggleBlockchainNetwork(network.networkId)
					}
				/>
			))}
		</tbody>
	);
};
